/** U盘保护模式 */
export enum UsbProtectMode {
  /** 大众模式 */
  normal = 0,
  /** 免打扰模式 */
  silent = 1,
  /** 打印店模式 */
  printShop = 2
}
